import { propsFilter } from './propsFilter';
import { trustedFilter } from './trustedFilter';

export default angular
  .module('redactieFilters', [])
  .filter('trusted', trustedFilter)
  .filter('propsFilter', propsFilter);
